/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-11 07:18:23
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Modal, Button } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import YesIcon from 'src/assets/images/subscription-v4/yes.svg';
import NoIcon from 'src/assets/images/subscription-v4/no.svg';
import StarIcon from 'src/assets/images/subscription-v4/star.svg';

type Props = {
  active: boolean,
  handleChangeModal: Function
};

type ComposedProps = Props & WithI18nProps;

class DowngradeInfoModal extends Component<ComposedProps> {
  render() {
    const { i18n, active, handleCloseModal, dataDowngradeCompare, handleContinueDowngrade } =
      this.props;

    if (!dataDowngradeCompare) return <></>;

    const data = dataDowngradeCompare.data;
    const title = dataDowngradeCompare.title;

    return (
      <Modal open={active} onClose={handleCloseModal} title={i18n.translate(title)}>
        <Modal.Section>
          <div className="DowngradeInfoModal">
            <div className="block left">
              <div className="header">
                {i18n.translate('AdminHTML.SubscriptionV4.Banner.DowngradeCompare.title_current')}
              </div>
              <div className="content">
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '20px' }}>
                  <div className="title">{i18n.translate(data.LEFT.plan)}</div>
                  <div className="features">
                    {data.LEFT.features.map((feature, idx) => {
                      return (
                        <div className="feature" key={idx}>
                          <p>{i18n.translate(feature.name)}</p>
                          <div className="item">
                            {feature.items.map((item, index) => {
                              return (
                                <div key={index}>
                                  <img
                                    alt="icon"
                                    src={item[0] ? YesIcon : NoIcon}
                                    width={10}
                                    height={10}
                                  />
                                  <span>{i18n.translate(item[1])}</span>
                                  {item[2] && (
                                    <img
                                      alt="icon"
                                      src={StarIcon}
                                      width={16}
                                      height={16}
                                    />
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <Button primary onClick={handleCloseModal}>
                  {i18n.translate('AdminHTML.SubscriptionV4.Banner.DowngradeCompare.btn_keep')}
                </Button>
              </div>
            </div>
            <div className="block right">
              <div className="header">
                {i18n.translate('AdminHTML.SubscriptionV4.Banner.DowngradeCompare.title_down')}
              </div>
              <div className="content">
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '20px' }}>
                  <div className="title">{i18n.translate(data.RIGHT.plan)}</div>
                  <div className="features">
                    {data.RIGHT.features.map((feature, idx) => {
                      return (
                        <div className="feature" key={idx}>
                          <p>{i18n.translate(feature.name)}</p>
                          <div className="item">
                            {feature.items.map((item, index) => {
                              return (
                                <div key={index}>
                                  <img
                                    alt="icon"
                                    src={item[0] ? YesIcon : NoIcon}
                                    width={10}
                                    height={10}
                                  />
                                  <span>{i18n.translate(item[1])}</span>
                                  {item[2] && (
                                    <img
                                      alt="icon"
                                      src={StarIcon}
                                      width={16}
                                      height={16}
                                    />
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <Button onClick={handleContinueDowngrade}>
                  {i18n.translate('AdminHTML.SubscriptionV4.Banner.DowngradeCompare.btn_down')}
                </Button>
              </div>
            </div>
          </div>
        </Modal.Section>
      </Modal>
    );
  }
}

export default withI18n()(DowngradeInfoModal);
